import React from 'react';
import { Building2, TrendingUp, Wallet } from 'lucide-react';
import { valueProps } from '../data/mockData';

const iconMap = {
  building: Building2,
  trending: TrendingUp,
  wallet: Wallet,
};

const ValueProps = () => {
  // Return null if no value props to display
  if (valueProps.length === 0) {
    return null;
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {valueProps.map((prop) => {
          const IconComponent = iconMap[prop.icon];
          return (
            <div
              key={prop.id}
              className="flex items-start space-x-4 p-5 rounded-2xl bg-[#131b2e] border border-[#1e2a45] shadow-[0_8px_30px_rgba(0,0,0,0.3)] hover:shadow-[0_15px_50px_rgba(0,0,0,0.4)] hover:border-[#3B82F6]/30 hover:translate-y-[-3px] transition-all duration-300 group cursor-pointer"
            >
              <div className="flex-shrink-0 w-14 h-14 bg-gradient-to-b from-[#1e2a45] to-[#131b2e] rounded-xl flex items-center justify-center shadow-[0_4px_0_0_#050810,inset_0_2px_4px_rgba(255,255,255,0.05)] group-hover:shadow-[0_2px_0_0_#050810,inset_0_2px_4px_rgba(255,255,255,0.05)] group-hover:translate-y-[2px] transition-all duration-200 border border-[#1e2a45]">
                <IconComponent className="h-6 w-6 text-[#3B82F6]" />
              </div>
              <div>
                <h3 className="font-bold text-[#3B82F6] text-base">
                  {prop.title}
                </h3>
                <p className="text-sm text-gray-400 mt-1">
                  {prop.description}
                </p>
              </div>
            </div>
          );
        })}        
      </div>
      
      {/* Divider */}
      <div className="border-t border-[#1e2a45] mt-8" />
    </div>
  );
};

export default ValueProps;
